import React from 'react';
import { Route } from 'react-router';
import { willRequireLogin } from '../Auth/index';
import AppPushPageContainer from '../AppPushPage/AppPushPageContainer';
import BreadCrumb from '../Common/BreadCrumb';

const PageWrapper = (props) => {
  return (
    <div>
      {props.banner}
      <BreadCrumb {...props}/>
      <div className='mb-6'/>
        <AppPushPageContainer {...props}/>
    </div>
  );
};

const Routes = (
    <Route
      label="App Voucher"
      helmet={{
        title: 'App Voucher"',
        metaDescription: 'App Voucher"'
      }}
      component={willRequireLogin(PageWrapper)} path='appvoucher'>
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/AppPushPageRoutes.js